<template>
  <a-layout-content :class="!monitoring ? 'p-all' : ''" v-if="data.length !== 0">
    <a-spin :spinning="pageLoading">
      <a-row :gutter="16">
        <a-col :xs="24" :lg="16">
          <a-card>
            <div slot="title">
              <span class="d-block">Manifest Cuti</span>
              <small>{{data.invoice.no_cuti}}</small>
            </div>
            <a-button
              size="default"
              slot="extra"
              icon="printer"
              @click="handlePrint"
            >{{!isMobile ? 'Print Manifest' : '' }}</a-button>

            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title" for>Tanggal Buat</span>
                <span class="list-desc">{{data.invoice.tgl_buat}}</span>
              </li>
              <li>
                <span class="list-title" for>User Pembuat</span>
                <span class="list-desc">{{data.invoice.user_pembuat}}</span>
              </li>
              <li>
                <span class="list-title" for>Unit Kerja</span>
                <span class="list-desc">{{data.invoice.unit_kerja}}</span>
              </li>
              <li>
                <span class="list-title" for>Jabatan</span>
                <span class="list-desc">{{data.invoice.jabatan}}</span>
              </li>
              <li>
                <span class="list-title" for>Tanggal Cuti</span>
                <span class="list-desc">{{data.invoice.tanggal_cuti}}</span>
              </li>
              <li>
                <span class="list-title" for>Keperluan</span>
                <span class="list-desc">{{data.invoice.keperluan}}</span>
              </li>
              <li>
                <span class="list-title" for>Hak Cuti Yang Diambil</span>
                <span class="list-desc">{{data.invoice.cuti_diambil}}</span>
              </li>
              <li>
                <span class="list-title" for>Sisa Cuti</span>
                <span class="list-desc">{{data.invoice.sisa_cuti}}</span>
              </li>
            </ul>
          </a-card>

          <a-card class="m-top" v-if="data.jenis !== 'Manifest'">
            <div slot="title">Tindakan Manifest</div>

            <a-form :form="form">
              <a-form-item class="m-remove" label="Catatan">
                <a-textarea
                  placeholder="Tulis catatan disini ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', {rules: [{required: true}]}]">
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{item.aksi}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleAction" block type="primary" html-type="submit">Simpan</a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="24" :lg="8" :class="isMobile ? 'm-top' : ''">
          <a-collapse activeKey="1" forceRender>
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <h4 class="margin-remove">Status</h4>
                <div>
                  <H-Status :status="data.lastStatus" />
                  <a-button @click="handleHistory" type="default" size="small" class="m-right">
                    <a-icon type="undo" />
                    {{!isMobile ? 'Riwayat' : ''}}
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="grey">
                  <div class="m-timeline-title">Pembuat - {{data.invoice.user_pembuat}}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{data.invoice.tgl_buat}}</h4>
                    <span
                      class="m-text-small"
                    >{{data.invoice.keperluan ? data.invoice.keperluan : 'Tidak Ada Keperluan'}}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">CREATED</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  :color="workflow.status === 'On Process' || workflow.status === 'Delivered' ? 'green' : workflow.status === 'Waiting' ? 'grey' : workflow.status === 'Rejected' || workflow.status === 'Revised' ? 'red' : 'grey'"
                  v-for="workflow in data.status_app"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">{{workflow.actor}} - {{workflow.tlc}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{workflow.tanggal_aksi}}</h4>
                    <span class="m-text-small" v-if="workflow.remark">{{workflow.remark}}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <H-Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </a-spin>

    <a-modal v-model="history" @ok="handleHistory" :footer="null">
      <span slot="title">
        <a-icon type="reload" />&nbsp;History Status
      </span>

      <ul class="list-wrapper bordered">
        <li v-for="history in data.notifikasi" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="d-flex justify-between">
              <h3 class="m-remove list-title">{{history.as_from}} | {{history.tlc_from}}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{history.tgl_notif}}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="d-flex justify-between">
              <h3
                class="m-remove list-title"
                v-if="(history.aksi === '4' && history.deskripsi === 'Edited') || history.deskripsi === 'Revised'"
              >{{history.as_from}} | {{history.tlc_from}}</h3>
              <h3 class="m-remove list-title" v-else>{{history.as_to}} | {{history.tlc_to}}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="list-desc">{{history.tgl_notif}}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";

export default {
  name: "manifest",
  props: ["id"],
  components: {
    "H-Status": Status
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      data: {invoice: {no_cuti:null}},
      history: false,
      pageLoading: false,
      monitoring: false
    };
  },
  watch: {
    id() {
      if (this.id) {
        this.fetching();
      }
    }
  },
  computed: {
    ...mapGetters(["getAuth"])
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    if (
      this.$router.currentRoute.name == "hrd.mon.manifest.cuti" ||
      this.$router.currentRoute.name == "al.mon.manifest.cuti" ||
      this.$router.currentRoute.name == "dir.mon.manifest.cuti"
    ) {
      this.monitoring = true;
    } else {
      this.monitoring = false;
    }
    this.fetching();
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
  },
  methods: {
    handleHistory() {
      this.history = true;
    },
    async fetching() {
      this.pageLoading = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "cuti",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.pageLoading = false;
          if (response.data) {
            this.data = {
              invoice: response.data.invoice[0],
              aksi: response.data.aksi,
              jenis: response.data.jenis,
              notifikasi: response.data.notifikasi,
              status_app: response.data.status_app
            };
          }
        })
        .catch(err => {
          console.log(err.response);
          this.pageLoading = false;
        });
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.$notification.error({
            message: "Error",
            description: "Pilih Aksi Terlebih Dahulu!"
          });
          return;
        }

        axios({
          method: "post",
          url: this.$serviceUrl + "cuti/approval",
          processData: false,
          data: {
            id_cuti: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan ? values.catatan : ""
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            this.$notification.success({
              message: "Sukses",
              description: "Data telah berhasil diproses!"
            });
            Event.$emit("refreshNotification", true);
            this.$router.go();
          })
          .catch(err => {
            console.log("error : " + err);
          });
      });
    },
    handlePrint() {
      this.pageLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "cuti/cetak_cuti",
        responseType: "blob",
        params: {
          id_cuti: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.pageLoading = false;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan system, error code 404!"
            });
          }
          this.pageLoading = false;
          this.$router.go();
        });
    }
  }
};
</script>

<style>
</style>
